import { CaretLeft } from '@core/assets/CaretLeft';
import { MODAL_BACK_BUTTON } from '@core/components/testIds';
import { useContextTranslation } from '@core/i18n';
import { ControlsButton } from '@src/core/components/ControlsButton/ControlsButton';
/**
 * Back Button for modals.
 */
export const ButtonBack = ({ onClick, asset, ref = null, }) => {
    const { t } = useContextTranslation();
    return (<ControlsButton className="cy-drawer_back" onClick={onClick} size={40} imgSize={30} src={asset || <CaretLeft label={t('player:Back')}/>} aria-label={t('player:Back')} ref={ref} data-testid={MODAL_BACK_BUTTON}/>);
};
